
import React from 'react'
import { useSelector } from 'react-redux';
function PrivacyContainer({ layout }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);


    return (
        <section className='contact_container'>
            <div className='contact_box'>
                <h5 className='text-center fw-bold mb-3'>{currentLocal.home.privacy}</h5>
{currentLocal && currentLocal.language === "English" ?
<p>

We respect your privacy, and this policy explains how we collect, use, and protect your personal information when you visit our website  or use our services.
We collect the following information: Personal information such as name, email address, phone number, and billing and shipping addresses; Payment information such as credit or debit card details, which is securely processed through a payment provider; Account information such as login information and order history; Technical data such as IP address, browser type, device information, and cookies.
We use your information to process and deliver orders, improve our site and services, communicate with you regarding requests or offers, provide technical and customer support, and comply with legal obligations.
We use appropriate security measures such as encryption (SSL) and secure servers to prevent unauthorized access or misuse of your data.
We use cookies to improve your experience, analyze site performance, and provide personalized suggestions. You can disable them in your browser settings if you wish.
We do not sell your personal information. We may only share it with payment service providers, shipping and delivery companies, and IT service providers. All partners are required to protect your data and use it only for the purpose of providing the service to you.
You have the right to access and update your personal data, request the deletion of your account, and opt out of marketing communications.
For inquiries or to exercise your rights, please contact us via phone at +201228200565.
We may update this Privacy Policy from time to time, and any changes will be posted on this page with the new date.

</p>
:
<div>
<p>
نحن نحترم خصوصيتك، وهذه السياسة تشرح كيف نقوم بجمع واستخدام وحماية معلوماتك الشخصية عند زيارتك لموقعنا الإلكتروني  أو استخدام خدماتنا.
نقوم بجمع المعلومات التالية: المعلومات الشخصية مثل الاسم، البريد الإلكتروني، رقم الهاتف، وعناوين الفواتير والشحن. معلومات الدفع مثل بيانات البطاقة الائتمانية أو بطاقة الخصم، ويتم معالجتها بشكل آمن عبر مزود الدفع. معلومات الحساب مثل بيانات تسجيل الدخول وسجل الطلبات. البيانات التقنية مثل عنوان IP ونوع المتصفح ومعلومات الجهاز وملفات تعريف الارتباط (الكوكيز).
نستخدم معلوماتك من أجل معالجة الطلبات وتسليمها، وتحسين موقعنا وخدماتنا، والتواصل معك بشأن الطلبات أو العروض، وتقديم الدعم الفني وخدمة العملاء، والامتثال للالتزامات القانونية.
نستخدم تدابير أمنية مناسبة مثل التشفير (SSL) والخوادم الآمنة للحد من الوصول غير المصرح به أو إساءة استخدام بياناتك.
نستخدم ملفات تعريف الارتباط (الكوكيز) لتحسين تجربتك وتحليل أداء الموقع وتقديم اقتراحات مخصصة، ويمكنك تعطيلها من إعدادات المتصفح إذا رغبت.
نحن لا نبيع معلوماتك الشخصية. قد نشاركها فقط مع مزودي خدمات الدفع وشركات الشحن والتوصيل ومزودي خدمات تقنية المعلومات، ويُطلب من جميع الشركاء حماية بياناتك وعدم استخدامها إلا لغرض تقديم الخدمة لك.
لديك الحق في الوصول إلى بياناتك الشخصية وتحديثها، وطلب حذف حسابك، وإلغاء الاشتراك في الرسائل التسويقية.
للاستفسار أو لممارسة حقوقك، يرجى التواصل معنا عبر البريد الإلكتروني: support@smileheavenglow.com.
قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر، وسيتم نشر أي تعديلات على هذه الصفحة مع التاريخ الجديد.
</p>

</div>

}
            </div>
        </section>)
}

export default PrivacyContainer